<template>
    <div>
        <div class="page-header pr-0">
            <h2>
                <a href="#">
                    <i class="fas fa-book-open"></i>
                </a>
            </h2>

            <ol class="breadcrumbs">
                <li class="active">
                    <span>Restaurant</span>
                </li>

                <li>
                    <span class="text-muted">Cartas digitales</span>
                </li>
            </ol>

            <div class="right-wrapper pull-right">
                <button class="btn btn-custom btn-sm mt-2 mr-2" @click.prevent="clickCreate()">
                    <i class="fa fa-plus-circle"></i>
                    Nueva carta
                </button>
            </div>
        </div>

        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">Listado de cartas digitales</h3>
            </div>

            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Nombre</th>
                                <th>Establecimiento</th>
                                <th>Diseño</th>
                                <th>Estado</th>
                                <th>Predeterminada</th>
                                <th class="text-right">Acciones</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(row, index) in records" :key="row.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ row.name }}</td>
                                <td>{{ row.establishment }}</td>
                                <td>{{ row.template }}</td>

                                <td>
                                    <el-tag :type="row.published ? 'success' : 'info'">
                                        {{ row.published ? 'Publicada' : 'Borrador' }}
                                    </el-tag>
                                </td>

                                <td>
                                    <el-tag :type="row.is_default ? 'success' : 'info'">
                                        {{ row.is_default ? 'Sí' : 'No' }}
                                    </el-tag>
                                </td>

                                <td class="text-right">
                                    <button v-if="row.published" type="button" class="btn btn-xs btn-primary"
                                        @click.prevent="openPublicMenu(row)">
                                        <i class="fa fa-external-link-alt"></i>
                                        Abrir carta
                                    </button>

                                    <button v-if="row.published" type="button" class="btn btn-xs btn-secondary"
                                        @click.prevent="copyPublicUrl(row)">
                                        <i class="fa fa-copy"></i>
                                        Copiar enlace
                                    </button>

                                    <button class="btn btn-xs btn-success" @click.prevent="openPreview(row)">
                                        Vista previa
                                    </button>

                                    <button class="btn btn-xs btn-info" @click.prevent="clickCreate(row.id)">
                                        Editar
                                    </button>

                                    <button class="btn btn-xs btn-danger" @click.prevent="clickDelete(row.id)">
                                        Eliminar
                                    </button>
                                </td>
                            </tr>

                            <tr v-if="records.length === 0">
                                <td colspan="7" class="text-center">
                                    No existen cartas registradas.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <menu-form :showDialog.sync="showDialog" :recordId="recordId" @saved="getRecords">
        </menu-form>
    </div>
</template>

<script>
import { deletable } from '@mixins/deletable'
import MenuForm from './form.vue'

export default {
    mixins: [deletable],

    components: {
        MenuForm,
    },

    data() {
        return {
            resource: 'restaurant/v2/menus',
            records: [],
            recordId: null,
            showDialog: false,
        }
    },

    created() {
        this.getRecords()
    },

    methods: {
        getRecords() {
            this.$http
                .get(`/${this.resource}/records`)
                .then(response => {
                    this.records = response.data.data
                })
        },

        clickCreate(id = null) {
            this.recordId = id
            this.showDialog = true
        },

        clickDelete(id) {
            this.destroy(`/${this.resource}/${id}`)
                .then(() => this.getRecords())
        },

        openPreview(row) {
            window.open(row.preview_url, '_blank')
        },
        openPublicMenu(row) {
            if (!row.published) {
                this.$message.warning(
                    'La carta todavía no está publicada'
                )

                return
            }

            window.open(row.public_url, '_blank')
        },
        copyPublicUrl(row) {
            if (!row.published) {
                this.$message.warning(
                    'Primero debe publicar la carta'
                )

                return
            }

            const input = document.createElement('textarea')

            input.value = row.public_url
            input.setAttribute('readonly', '')
            input.style.position = 'absolute'
            input.style.left = '-9999px'

            document.body.appendChild(input)

            input.select()
            input.setSelectionRange(0, input.value.length)

            try {
                document.execCommand('copy')

                this.$message.success(
                    'Enlace copiado correctamente'
                )
            } catch (error) {
                this.$message.error(
                    'No se pudo copiar el enlace'
                )
            }

            document.body.removeChild(input)
        },
    },
}
</script>


// WEBPACK FOOTER //
// modules/Restaurant/Resources/assets/js/views/v2/menus/index.vue